import { defineComponent as _defineComponent } from 'vue'
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { TreeOptionsBranchOption } from '../../interfaces/form';
import ChoiceBranch from './ChoiceBranch.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChoiceTreeFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { emit }) {

const props = __props;





const formElement = useFormElement({
  emit,
  props,
});

const { modelStateRef, field, setModelState, setValue } = formElement;

const tree = modelStateRef('options');

const showCallText = modelStateRef('showCallText', true, true);

function onChoice(choice: TreeOptionsBranchOption[]) {
  if (choice.length) {
    const final = !choice[choice.length - 1].next;
    setModelState('final', final);
    setModelState('meta', choice[choice.length - 1].meta);
  }
  setValue(
    choice.map((c) => c.value),
    true
  );
}

return { __sfc: true,props, emit, formElement, modelStateRef, field, setModelState, setValue, tree, showCallText, onChoice, ChoiceBranch }
}

})